import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconAlt: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-IconAlt"><Path d="M6.73315 12.5886L7.38062 10.3142H7.40967L8.05713 12.5886H6.73315Z" fill="currentColor"/><Path fillRule="evenodd" clipRule="evenodd" d="M2 20V4H22V20H2ZM6.46338 9.01099L4.44629 15H6.04419L6.41772 13.6843H8.37256L8.74609 15H10.344L8.3269 9.01099H6.46338ZM10.9209 9.01099V15H14.9219V13.7756H12.4441V9.01099H10.9209ZM16.3123 10.2354V15H17.8313V10.2354H19.4832V9.01099H14.6604V10.2354H16.3123Z" fill="currentColor"/></CentralIconBase>;
});

export default IconAlt;
